import React from 'react';
import { Card } from 'primereact/card';
import { ProgressBar } from 'primereact/progressbar';
import { Tag } from 'primereact/tag';

const DashboardCard = ({
    title,
    value,
    icon,
    color = '#2196F3',
    chartPurpose = null, // definimos el propósito del dato
    total = 1,           // útil para "de X"
}) => {
    // Calculamos visual auxiliar si aplica
    const showProgress = chartPurpose === 'porcentajeAbiertas';
    const showBadge = chartPurpose === 'cuentasVencidas' || chartPurpose === 'quitaOQuebranto';

    let percentage = 0;
    if (showProgress && typeof value === 'string' && value.includes('de')) {
        const [val, tot] = value.split('de').map(v => parseInt(v.trim()));
        percentage = Math.round((val / tot) * 100);
    }

    return (
        <Card
            className="shadow-2 border-round-lg"
            style={{
                height: '183px',
                backgroundColor: '#ffffff',
                width: '90%',
                margin: "auto",
                padding: '1.5rem',
                position: 'relative',
            }}
        >
            <div className="flex justify-content-between align-items-start h-full">
                <div>
                    <div className="text-sm text-blue-500 font-medium">{title}</div>
                    <div className="text-3xl font-bold text-blue-700 mt-1">{value}</div>

                    {/* Visual adicional */}
                    {showProgress && (
                        <ProgressBar
                            value={percentage}
                            style={{ height: '8px', marginTop: '0.5rem' }}
                            color={color}
                        />
                    )}

                    {showBadge && (
                        <Tag
                            value={value}
                            severity="info"
                            style={{ marginTop: '0.5rem', fontSize: '0.8rem' }}
                        />
                    )}
                </div>

                <div className="text-3xl" style={{ color }}>
                    {icon}
                </div>
            </div>
        </Card>
    );
};

export default DashboardCard;
